import { useContext } from 'react';
import { DragInterfaceContext } from './MouseDragProvider';
import { nodeEq } from './utils';
import { NodeBoundsContext } from './Contexts';

function findNode(nodeLocator,nodeList=[]){
  return nodeList.find(node => nodeEq(nodeLocator,node));
}

export default function useResolvedProperties(nodeLocator,properties){

  const {changes} = useContext(NodeBoundsContext);

  

  const dragInterface = useContext(DragInterfaceContext);
  const dragInfo = dragInterface?.getDragInfo?.();
  let changeTargets = dragInfo?.targetLocations;


  let resolvedProperties;
  

  let isChangingProperties = changeTargets && findNode(
    nodeLocator,
    changeTargets
  );

  if( isChangingProperties ){
    resolvedProperties = {
      ...properties,
      ...(changes?.value || {})
    }
  }else{
    resolvedProperties = properties;
  }

  if( !resolvedProperties ){
    debugger;
  }

  return resolvedProperties;

}
